import AnimatedSection from "./AnimatedSection";
import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import { AlertTriangle, Wallet, Lock } from "lucide-react";

const icons = [AlertTriangle, Wallet, Lock];

const PainPointsSection = () => {
  const { lang } = useLang();
  const t = translations[lang].painPoints;

  return (
    <section data-testid="pain-points-section" className="bg-slate-50 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        {/* Mobile image */}
        <AnimatedSection>
          <img
            src={t.image}
            alt="Operaciones de logistica e importacion internacional"
            data-testid="pain-image-mobile"
            className="lg:hidden rounded-2xl w-full h-[200px] sm:h-[260px] object-cover shadow-lg mb-10"
            loading="lazy"
          />
        </AnimatedSection>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <AnimatedSection>
              <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-semibold text-electric mb-4 font-body">{t.overline}</p>
              <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-navy font-heading mb-10 max-w-lg">{t.headline}</h2>
            </AnimatedSection>
            <div className="space-y-4">
              {t.problems.map((problem, i) => {
                const Icon = icons[i];
                return (
                  <AnimatedSection key={i} delay={i * 0.1}>
                    <div data-testid={`problem-card-${i}`} className="bg-navy rounded-2xl p-6 text-white">
                      <div className="flex items-start gap-4">
                        <div className="shrink-0 w-10 h-10 rounded-xl bg-red-500/20 flex items-center justify-center">
                          <Icon size={20} className="text-red-400" />
                        </div>
                        <div>
                          <h3 className="text-base font-bold mb-1 font-heading">{problem.title}</h3>
                          <p className="text-slate-300 text-sm leading-relaxed font-body">{problem.desc}</p>
                        </div>
                      </div>
                    </div>
                  </AnimatedSection>
                );
              })}
            </div>
            <AnimatedSection delay={0.4}>
              <div className="mt-8">
                <div className="inline-flex items-center gap-3 bg-navy text-white px-6 py-3 rounded-xl">
                  <div className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-pulse" />
                  <span className="font-semibold text-base font-heading">{t.resolution}</span>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Desktop image */}
          <AnimatedSection delay={0.2}>
            <img
              src={t.image}
              alt="Operaciones de logistica e importacion internacional"
              data-testid="pain-image-desktop"
              className="hidden lg:block rounded-2xl w-full h-[500px] object-cover shadow-xl"
              loading="lazy"
            />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default PainPointsSection;
